import { z } from "zod"

// Version 1 ---------------------
export const ProductsSettingsV1 = z.object({
  productCount: z.union([z.literal("one"), z.literal("two"), z.literal("three")]),
  hideProducts: z.union([z.literal("true"), z.literal("false"), z.literal("auto")]),
  direction: z.union([z.literal("vertical"), z.literal("horizontal")]),
  // productDivider: z.union([z.literal("show"), z.literal("hide")]),
  // footerPosition:
  selectedBorderWidth: z.string(),
  selectedCheckBoxImage: z.string(),
  borderWidth: z.string(),
  borderColor: z.string(),
  unselectedCheckBoxImage: z.string(),
  checkMarkMargin: z.string(),
  reverseDirection: z.union([z.literal("true"), z.literal("false")]),
  showProductCheckMark: z.union([z.literal("show"), z.literal("hide")]),
  primaryProductBadge: z.union([z.literal("show"), z.literal("hide")]),
  secondaryProductBadge: z.union([z.literal("show"), z.literal("hide")]),
  tertiaryProductBadge: z.union([z.literal("show"), z.literal("hide")]),
  // productDescription: z.union([z.literal("show"), z.literal("hide")]),
})

export type TProductsSettingsV1 = z.infer<typeof ProductsSettingsV1>

export const ProductsElementV1 = z.object({
  id: z.string(),
  name: z.literal("products"),
  settings: ProductsSettingsV1,
})

export type TProductsElementV1 = z.infer<typeof ProductsElementV1>

// Version 2 ---------------------
export const ProductsSettingsV2 = z.object({
  productCount: z.union([z.literal("one"), z.literal("two"), z.literal("three")]),
  hideProducts: z.union([z.literal("true"), z.literal("false"), z.literal("auto")]),
  direction: z.union([z.literal("vertical"), z.literal("horizontal")]),
  selectedBorderWidth: z.string(),
  selectedCheckBoxImage: z.string(),
  borderWidth: z.string(),
  borderColor: z.string(),
  unselectedCheckBoxImage: z.string(),
  checkMarkMargin: z.string(),
  reverseDirection: z.union([z.literal(true), z.literal(false)]),
  showProductCheckMark: z.union([z.literal("show"), z.literal("hide")]),
  primaryProductBadge: z.union([z.literal("show"), z.literal("hide")]),
  secondaryProductBadge: z.union([z.literal("show"), z.literal("hide")]),
  tertiaryProductBadge: z.union([z.literal("show"), z.literal("hide")]),
})

export type TProductsSettingsV2 = z.infer<typeof ProductsSettingsV2>

export const ProductsElementV2 = z.object({
  id: z.string(),
  name: z.literal("products"),
  settings: ProductsSettingsV2,
})

export type TProductsElementV2 = z.infer<typeof ProductsElementV2>

// Latest ---------------------
export const ProductsElement = ProductsElementV2
export type TProductsElement = TProductsElementV2
export const ProductsSettings = ProductsSettingsV2
export type TProductsSettings = TProductsSettingsV2
